import { darken, remToPx } from 'polished';
import styled, { css } from 'styled-components';
import { tryAnd } from '../CodesThatsGottaGoSomewhereElse';


export const ColorPreview = styled.div<{ color: string | null, scale?: number, clickable?: boolean }>`
    position: relative;
    width: ${p => remToPx(1.25 + (.25 * (p.scale ?? 1)))};
    height: ${p => remToPx(1.25 + (.25 * (p.scale ?? 1)))};
    background-color: ${p => p.color || '#fff'};
    border-radius: 50%;
    border: solid 1px ${p => tryAnd(() => darken(0.1, p.color || '#fff'))};
    box-sizing: border-box;

    ${p => p.color ? '' : `
    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: .75rem;
        bottom: 0;
        width: 2px;
        background: darkred;
        transform: translateX(-1px) rotate(45deg);
    }
    `}

    ${p => p.clickable ? css`
        cursor: pointer;
        &:hover {
            border: solid 1px ${tryAnd(() => darken(0.2, p.color || '#fff'))};
        }
        &:active {
            border: solid 1px ${tryAnd(() => darken(0.3, p.color || '#fff'))};
        }
    ` : ''}
`;
